import {
  PAGE_TYPE_HOMEPAGE,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
} from 'shared/consts'
import {
  CAT_MORE_PRODUCTS_ON_SECOND_CSW,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_MORE_CLICK,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiment,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant } = publicRuntimeConfig?.publicConfig || {}

  const { experiments = [], pageType = '' } =
    publicRuntimeConfig?.pageProperties || {}

  const { variant, isEnabled } = getExperiment(
    CAT_MORE_PRODUCTS_ON_SECOND_CSW,
    experiments
  )

  if (pageType !== PAGE_TYPE_HOMEPAGE || !isEnabled) {
    return
  }

  void activateExperiment(CAT_MORE_PRODUCTS_ON_SECOND_CSW)

  if (variant === EXPERIMENT_VARIATION.V1) {
    const xSellWidgets = document.querySelectorAll(
      '[data-clientside-api-call~="fetchCrossSell"]'
    )

    const widgetIndex = [TENANT_COM, TENANT_FR, TENANT_CH].includes(tenant)
      ? 2
      : 1

    xSellWidgets[widgetIndex]?.addEventListener('click', event => {
      const element = <HTMLElement>event.target

      if (element.closest('.o-ProductSliderItem')) {
        trackOptimizelyEvent(CSW_PRODUCT_CLICK)
      }
      if (element.closest('.o-SliderHorizontal__show-more')) {
        trackOptimizelyEvent(CSW_SHOW_MORE_CLICK)
      }
    })
  }
}
